var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoBlack = function SvgLogoBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 43 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.25 21.969a.88.88 0 0 0-.242.51.874.874 0 0 0 .107.554c.095.174.235.3.415.383a.88.88 0 0 0 .561.064l19.956-4.112 19.956 4.112a.88.88 0 0 0 .562-.064.884.884 0 0 0 .415-.383.874.874 0 0 0 .107-.554.891.891 0 0 0-.242-.51L21.705.784a.886.886 0 0 0-.3-.21.896.896 0 0 0-.716 0 .903.903 0 0 0-.302.21L.25 21.969Z"
  })));
};
export default SvgLogoBlack;